import { InvoiceItemType } from 'entities/Invoice';
import { PaymentsStatisticsTotal } from 'entities/Warehouse';

const PAYMENT_ITEM_TYPE_ORDER: string[] = [
  InvoiceItemType.BOX,
  InvoiceItemType.OFFICE,
  InvoiceItemType.INSURANCE,
  InvoiceItemType.DEPOSIT,
  InvoiceItemType.LATE_CHARGE,
  InvoiceItemType.PENALTY,
  InvoiceItemType.PARKING_PLACE,
  InvoiceItemType.CLEANING,
  InvoiceItemType.RENTAL_ITEM,
  InvoiceItemType.RENT,
  InvoiceItemType.POSTAL_BOX,
  InvoiceItemType.CONTRACTUAL_PENALTY,
  InvoiceItemType.FALSE_ALARM_SMOKE_DETECTOR,
  InvoiceItemType.REPAIR_COSTS,
  InvoiceItemType.RENTING_STUFF,
  InvoiceItemType.DAMAGE_COMPENSATION,
  InvoiceItemType.ELECTRICITY_FEE,
  InvoiceItemType.DISPOSAL,
];

export const sortPaymentsStatistics = (items: PaymentsStatisticsTotal[]): PaymentsStatisticsTotal[] => {
  return [...items].sort((a, b) => {
    const indexA = PAYMENT_ITEM_TYPE_ORDER.indexOf(a.type);
    const indexB = PAYMENT_ITEM_TYPE_ORDER.indexOf(b.type);

    const orderA = indexA === -1 ? PAYMENT_ITEM_TYPE_ORDER.length : indexA;
    const orderB = indexB === -1 ? PAYMENT_ITEM_TYPE_ORDER.length : indexB;

    return orderA - orderB;
  });
};
